import register from 'ShopUi/app/registry';
import { importWithFallback } from 'PyzShopUi/scripts/utils/importWithFallback';

export default register('cookie-notice', () =>
    importWithFallback(
        /* webpackMode: "lazy" */
        () => import('./cookie-notice')
    ),
);
